<template>
  <div class="aboutGoods">
    <div v-if="facility=='app'" class="content">
      <App />
    </div>
    <div v-else>
      <Pc/>
    </div>
  </div>
</template>

<script>
import Pc from "./pc";
import App from "./app";
export default {
  components:{
    App,
    Pc
  },
  data(){
    return{
      facility:"",
    }
  },
  beforeMount(){
    this.facility = this.isMobile()
  },
  methods:{
    
  }
}
</script>

<style scoped>
  
</style>